<template>
    <div>
        <el-row>
            <el-col :span="14" :offset="5" class="columm">
                <h3 class="text-center"><b>Be part of the change!</b></h3>

             <!--    <p class="text-center">Talk and contribute to world.</p> -->
            </el-col>
        </el-row>
 <!--        <el-row :gutter="20">
            <el-col :span="12">
                <div class="grid-content well">
                    <el-row>
                        <el-col :span="10" :offset="7" class="columm">
                            <el-button type="success" class="signup">Continue with Google</el-button>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="10" :offset="7" class="columm">
                            <el-button class="signup facebook">Continue with Facebook</el-button>
                        </el-col>
                    </el-row> 
                    <el-row v-if="anonymous">
                        <el-col :span="10" :offset="7" class="columm">
                            <el-button type="primary" class="signup"
                                       @click="[email=true,anonymous=false, form.errors = []]">
                                Create account using email
                            </el-button>
                        </el-col>
                    </el-row>
                    <el-row v-else>
                        <el-col :span="10" :offset="7" class="columm">
                            <el-button type="info" class="signup"
                                       @click="[email=false,anonymous=true, form.errors = []]">Anonymous
                                Account
                            </el-button>
                        </el-col>
                    </el-row>
                </div>
            </el-col>
            <el-col :span="12">-->
        <div class="grid-content form">
            <el-form ref="form" :model="form" class="signupForm">

                <el-form-item :label="anonymous ? 'Name' : 'Full Name'" class="label150">
                    <el-input value="Anonymous" disabled v-if="anonymous"></el-input>
                    <el-input v-model="form.name" @change="setUserName" v-else></el-input>
                    <el-alert v-for="e in form.errors.name"
                              :title="e"
                              type="error"
                              :key="e">
                    </el-alert>
                </el-form-item>

                <el-row>
                    <a v-if="anonymous" class="realnamebutton"
                               @click="[email=true,anonymous=false, form.errors = []]">
                        I want to use Real Name
                    </a>
                    <a v-else class="realnamebutton"
                       @click="[email=false,anonymous=true, form.errors = []]">I want to be Anonymous
                    </a>
                </el-row>

                <el-form-item label="UserName" class="label150">
                    <el-input v-model="form.username">
                        <template slot="prepend">@</template>
                    </el-input>
                    <el-alert v-if="usernameNotTaken" title="username is not taken"
                              type="success">
                    </el-alert>

                    <el-alert v-for="e in form.errors.username"
                              :title="e"
                              type="error"
                              :key="e">
                    </el-alert>

                    <el-button class="check-availability-btn" size="mini" :type="buttonType"
                               v-if="showUsernameField"
                               @click.prevent="checkUserName(form.username)">check availability
                    </el-button>
                </el-form-item>

                <el-form-item :label="anonymous ? 'Email (Optional)' : 'Email'" class="label150">
                    <el-input type="email" v-model="form.email"></el-input>
                    <el-alert v-for="e in form.errors.email"
                              :title="e"
                              type="error"
                              :key="e"></el-alert>
                </el-form-item>

                <el-form-item label="Password" class="label150">
                    <el-input type="password" v-model="form.password"></el-input>
                    <el-alert v-for="e in form.errors.password"
                              :title="e"
                              type="error"
                              :key="e"></el-alert>
                </el-form-item>
  <!--
                <el-form-item label="Location">
                    <el-select v-model="form.location_id" filterable placeholder="Select Home Country">
                        <el-option
                                v-for="item in locations"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value"
                        ></el-option>
                    </el-select>
                    <el-alert v-for="e in form.errors.location_id"
                              :title="e"
                              type="error"
                              :key="e"></el-alert>
                </el-form-item>
-->
                <!--<el-form-item>-->
                <!--<el-form-item label="Confirm Password" label-width="125px">-->
                <!--<el-input type="password" v-model="form.password_confirmation"></el-input>-->
                <!--<el-alert v-for="e in form.errors.password_confirmation"-->
                <!--:title="e"-->
                <!--type="error"-->
                <!--:key="e"></el-alert>-->
                <!--</el-form-item>-->
                <!--</el-form-item>-->

<!--                         <el-form-item>
                    <el-form-item label="Country" class="label150">
                        <el-select v-model="form.location" placeholder="Country">
                            <el-option
                                    v-for="item in locations"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value">
                            </el-option>
                        </el-select>

                        <el-alert v-for="e in form.errors.location"
                                  :title="e"
                                  type="error"
                                  :key="e">
                        </el-alert>
                    </el-form-item>
                </el-form-item> -->

                <el-form-item label="" class="label150">
                    <vue-recaptcha :sitekey="Laravel.recaptchaKey"
                                   @verify="reCaptchaVerified"
                                   ref="recaptcha"
                                   @expired="reCaptchaExpired">
                    </vue-recaptcha>

                    <el-alert v-if="recapchaFail"
                              :title="recapchaFail"
                              type="error"
                              :key="recapchaFail">
                    </el-alert>

                    <el-alert v-if="form.errors['g-recaptcha-response']"
                              title="You didn't pass the reCAPTCHA check"
                              class="margin-bottom-1"
                              type="error"></el-alert>
                </el-form-item>

                <el-form-item label="" class="label150">
                    <div class="info-text">
                        By clicking "Sign Up" you indicate that you have read and agreed to Humtog's
                     <router-link to="/rules"
                     class="go-primary">rules,</router-link>
                     <router-link to="/tos"
                     class="go-primary">terms of service,</router-link>
                        and
                    <router-link to="/privacy-policy">privacy policy</router-link>.
                    </div>
                </el-form-item>

                <el-form-item>
                    <el-button type="primary" @click="onSubmit" style="width: 100%">Sign Up</el-button>
                </el-form-item>
            </el-form>
        </div>
        <!--     </el-col>
        </el-row>-->
    </div>
</template>
<script>
    import Helpers from '../../mixins/Helpers'
    import VueRecaptcha from 'vue-recaptcha';

    export default {
        mixins: [Helpers],
        components: {VueRecaptcha},
        data() {
            return {
                form: {
                    name: '',
                    username: '',
                    email: '',
                    password: '',
                    password_confirmation: '',
                    location_id: '2',
                   // location: '',
                    errors: [],
                    reCAPTCHA: ''
                },
                anonymous: false,
                showUsernameField: true,
                email: true,
                type: '',
           //     locations: [],
                buttonType: 'primary',
                usernameNotTaken: false,
                recapchaFail: '',
                locations: []
            }

        },
        created() {
            if (Helpers.computed.isLoggedIn()) {
                this.$router.push('/')
            }

          axios
            .get("/location?no_global=1")
            .then(response => this.location(response))
            .catch(error => console.log('could not fetch locations', error));

/*             axios.get(`${Laravel.url}/api/location`).then(response => {
                if (response.status == 200) {
                    this.locations = response.data.data.map(item => ({
                        label: item.name,
                        value: item.id
                    }));
                }
            }) */
        },
        methods: {
              location(response) {
                if (response.status == 200) {
                  let result = response.data.data.map(item => ({
                    label: item.name,
                    value: item.id
                  }));

                  this.locations = result;
                }
              },
            reCaptchaVerified(response) {
                this.form.reCAPTCHA = response;
            },

            reCaptchaExpired() {
                this.form.reCAPTCHA = '';
            },
            checkUserName(userName) {
                this.form.errors = []
                axios.post(`${Laravel.url}/api/check-user-name`, {
                    username: userName,
                    type: 'checkUserName'
                })
                    .then((response) => {
                        this.buttonType = 'success';
                        this.usernameNotTaken = true
                    })
                    .catch((error) => {
                        this.form.errors = error.response.data.errors
                        this.buttonType = 'danger';
                        this.usernameNotTaken = false

                    })
            },

            setUserName(val) {
                this.showUsernameField = true;
                this.form.username = val.split(" ").join("");
            },

            cancle() {
                this.$router.push('/')
            },
            onSubmit() {
                this.recapchaFail = '';
                if (this.email == true) {
                    this.type = 'email'
                } else {
                    this.type = 'anonymous'
                    this.form.name = 'Anonymous'
                }

                axios.post(`${Laravel.url}/register`, {
                    username: this.form.username,
                    email: this.form.email,
                    name: this.form.name,
                    type: this.type,
                    password: this.form.password,
                    location_id: this.form.location_id,
                  //   location: this.form.location,
                    'g-recaptcha-response': this.form.reCAPTCHA
                    // password_confirmation: this.form.password_confirmation
                }).then((response) => {
                    if (response.data == 'recaptcha fail') {
                        this.recapchaFail = 'recaptcha fail'
                    } else {
                        this.form.errors = []
                        window.location.href = '/discover-channels?newbie=1&sidebar=0'
                    }

                }).catch((error) => {
                    this.form.errors = error.response.data.errors
                }).finally(() => {
                    this.$refs.recaptcha.reset()
                })
            },
        }
    }
</script>
<style scoped>
    .well {
        border-right: black 1px solid;
        padding: 20px;
    }

    .form {
        text-align: right;
    }

    .columm {
        margin-bottom: 20px;
    }

    .signup {
        padding: 20px 0;
        border-radius: 5px;
        width: 320px;
    }

    .text-center {
        text-align: center;
    }

    .signupForm {
        width: 75%;
        margin: auto;
    }
    .label150{
        label-width:150px;
    }
    @media (max-width: 900px) {
        .signupForm {
        width: 100%;
    }
        .label150{
        label-width:5px;
    }
    }

    .submitButton {
        margin-top: 20px;
        padding: 15px 120px;
        margin-right: 10px;
    }

    .facebook {
        background: #3b5898;
        color: white;
    }

    .check-availability-btn {
        margin-top: 5px;
    }

    .info-text {
        font-size: 15px;
        text-align: left;
        line-height: 20px
    }
    .realnamebutton {
    float: right;
    font-size: 13px;
    cursor: pointer;
    padding-bottom: 6px;
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/auth/SignUp.vue